<template>
  <iCallDialog
    :open="open"
    :max-width="720"
    :max-height="560"
    data-test="settings-panel"
    @close="$emit('close')"
  >
    <iCallPanel
      title="Settings"
      close-label="Close settings"
      close-test-id="settings-panel-close"
      @close="$emit('close')"
    >
      <iRow
        gap="large"
        width="fill"
        height="fill"
        wrap="nowrap"
        vertical-align="top"
        :min-height="0"
      >
        <iColumn
          :width="200"
          gap="extraSmall"
          wrap="nowrap"
          role="tablist"
          data-test="settings-tabs"
        >
          <iCallNavItem
            v-for="tab in tabs"
            :key="tab.value"
            :icon="tab.icon"
            :selected="activeTab === tab.value"
            :data-test="`settings-tab-${tab.value}`"
            @click="activeTab = tab.value"
          >
            {{ tab.label }}
          </iCallNavItem>
        </iColumn>
        <iColumn
          width="fill"
          gap="standard"
          wrap="nowrap"
          :min-width="0"
          overflow="auto"
          data-test="settings-section"
        >
          <AudioSettingsSection
            v-if="activeTab === 'audio'"
            :available-audio-input-devices="availableAudioInputDevices"
            :available-output-devices="availableOutputDevices"
            :selected-microphone-device-id="selectedMicrophoneDeviceId"
            :selected-output-device-id="selectedOutputDeviceId"
            :noise-cancellation-mode="noiseCancellationMode"
            :audio-processing="audioProcessing"
            :mic-test="micTest"
            @change-microphone="$emit('change-microphone', $event)"
            @change-output="$emit('change-output', $event)"
            @change-noise-cancellation="$emit('change-noise-cancellation', $event)"
            @record-mic-test="$emit('record-mic-test')"
            @play-mic-test="$emit('play-mic-test')"
          />
          <VideoSettingsSection
            v-else
            :available-video-devices="availableVideoDevices"
            :selected-camera-device-id="selectedCameraDeviceId"
            :is-local-video-mirrored="isLocalVideoMirrored"
            @change-camera="$emit('change-camera', $event)"
            @toggle-mirror="$emit('toggle-mirror', $event)"
          />
        </iColumn>
      </iRow>
    </iCallPanel>
  </iCallDialog>
</template>

<script>
import VideoSettingsSection from "%/apps/video-engine/components/video-call/settings/VideoSettingsSection.vue";
import AudioSettingsSection from "%/apps/video-engine/components/video-call/settings/AudioSettingsSection.vue";

const TABS = [
  { value: "audio", label: "Audio", icon: "ic:outline-volume-up" },
  { value: "video", label: "Video", icon: "ic:outline-videocam" },
];

export default {
  name: "CallSettingsPanel",
  components: { VideoSettingsSection, AudioSettingsSection },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    availableVideoDevices: {
      type: Array,
      default: () => [],
    },
    availableAudioInputDevices: {
      type: Array,
      default: () => [],
    },
    availableOutputDevices: {
      type: Array,
      default: () => [],
    },
    selectedCameraDeviceId: {
      type: String,
      default: null,
    },
    selectedMicrophoneDeviceId: {
      type: String,
      default: null,
    },
    selectedOutputDeviceId: {
      type: String,
      default: null,
    },
    isLocalVideoMirrored: {
      type: Boolean,
      default: true,
    },
    noiseCancellationMode: {
      type: String,
      default: "standard",
    },
    audioProcessing: {
      type: Object,
      default: () => ({ supported: true, phase: "idle", captureMismatches: [] }),
    },
    micTest: {
      type: Object,
      default: () => ({ recording: false, playing: false, durationSeconds: 0 }),
    },
  },
  emits: [
    "close",
    "change-camera",
    "change-microphone",
    "change-output",
    "toggle-mirror",
    "change-noise-cancellation",
    "record-mic-test",
    "play-mic-test",
  ],
  data() {
    return {
      activeTab: "audio",
    };
  },
  computed: {
    tabs() {
      return TABS;
    },
  },
};
</script>
